import React, { useState } from 'react';
import { Box, Button } from '@material-ui/core';
import {
  HeadsetMic as CallCenterIcon,
  ExpandMore as ExpandIcon
} from '@material-ui/icons';
import useCallCenter from 'src/hooks/useCallCenter';
import CallCenterDialog from './CallCenterDialog';

export default function CallCenterFilter() {
  const { areAllCallCentersSelected, activeCallCenters, allCallCenters } = useCallCenter();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  if (!allCallCenters || allCallCenters.length === 0) {
    return null;
  }

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const handleOpenDialog = () => {
    if (allCallCenters?.length > 1) {
      setIsDialogOpen(true);
    }
  };

  let buttonText;
  if (activeCallCenters.length === 1) {
    const activeCallCenter = activeCallCenters[0];
    buttonText = activeCallCenter.callCenterName;
  } else if (allCallCenters.length > 0 && areAllCallCentersSelected()) {
    buttonText = 'All Call Centers';
  } else if (activeCallCenters.length === 2) {
    buttonText = '2 Call Centers';
  } else {
    buttonText = 'Many Call Centers';
  }

  const EndIcon = allCallCenters?.length > 1
    ? <ExpandIcon fontSize="small" />
    : null;

  return (
    <Box display="inline-flex" alignItems="center" mr={2}>
      <Button
        id="button-call-centers"
        variant="outlined"
        color="inherit"
        startIcon={<CallCenterIcon />}
        endIcon={EndIcon}
        onClick={handleOpenDialog}
      >
        {buttonText}
      </Button>
      <CallCenterDialog
        open={isDialogOpen}
        onClose={handleCloseDialog}
      />
    </Box>
  );
}
